import React from 'react'
import { eformInput } from '../../../common/cssclasses';
import { useTranslate } from '../../../components/TranslationText';
import EahsForm from '../../../components/EahsForm';

export default function SemenReason({ orderDetails }) {
    const { translate } = useTranslate();
    return (
        <EahsForm title={translate('web.comments', 'Reason')}>
            <div className={eformInput}>
                <textarea
                    className="form-control"
                    rows={3}
                    value={orderDetails.externalComment}
                    disabled
                    style={{ backgroundColor: '#f8f9fa' }}
                />
            </div>
        </EahsForm>
    );
}